import Swiper from 'swiper';

export default function usePageBuilderSlider(swiperClassName, options = {}, conditionalOptions = '') {

    const setSwiperClasses = sliderElm => {
        sliderElm.classList.add('swiper');
        sliderElm.firstElementChild.classList.add('swiper-wrapper');

        const swiperChildren = sliderElm.firstElementChild.children;

        if (typeof conditionalOptions === 'function') {
            conditionalOptions({options, swiperChildren});
        }

        Array.from(swiperChildren).forEach(slide => {
            slide.classList.add('swiper-slide');
        });
    };

    const buildSwiperSlider = sliderElm => {
        return new Swiper(sliderElm, options);
    };

    const pageBuilderEditor = document.querySelector('.browser-content');

    if (pageBuilderEditor === null) {
        // Get all the sliders on the page
        const allSliders = document.querySelectorAll(swiperClassName);

        // Loop over all the fetched sliders and apply Swiper on each one.
        allSliders.forEach(slider => {
            setSwiperClasses(slider);
            buildSwiperSlider(slider);
        });
    }

}
